import PropTypes from 'prop-types'
import React, { Component } from 'react'
import List from '../List/List.jsx'
import Pagination from '../Pagination/Pagination.jsx'

class DataTable extends Component {
  constructor (props) {
    super(props)

    this.state = {
      pageCount: Math.ceil(
        this.props.objectList.length / this.props.objectsPerPage
      ),
      currentPage: 1,
      sort: this.props.sort,
      sortAsc: this.props.sortAsc,
      items: this.props.objectList
    }
  }

  static propTypes = {
    objectsPerPage: PropTypes.number,
    objectList: PropTypes.array,
    footerObject: PropTypes.object,
    columns: PropTypes.array,
    renderCustomCell: PropTypes.func,
    onRenderFooter: PropTypes.func,
    onPaginate: PropTypes.func,
    actionIcon: PropTypes.string,
    sort: PropTypes.string,
    sortAsc: PropTypes.bool,
    onSort: PropTypes.func,
    onView: PropTypes.func,
    onSettings: PropTypes.func,
    onClickRow: PropTypes.func
  }

  static defaultProps = {
    objectsPerPage: 15,
    objectList: null,
    footerObject: null,
    columns: [],
    renderCustomCell: null,
    onRenderFooter: null,
    onPaginate: null,
    actionIcon: null,
    sort: null,
    sortAsc: true,
    onSort: null,
    onView: null,
    onSettings: null,
    onClickRow: null
  }

  static getDerivedStateFromProps (props, state) {
    const { objectList, objectsPerPage } = props
    const { items, currentPage } = state

    const newCurrentPage = objectList.length === items.length ? currentPage : 1

    return {
      ...state,
      pageCount: Math.ceil(objectList.length / objectsPerPage),
      items: objectList,
      currentPage: newCurrentPage
    }
  }

  handlePagination = pageNr => {
    this.setState({ currentPage: pageNr })
  }

  handleSort = columnIdentifier => {
    const { objectList } = this.props
    const sortAsc =
      this.state.sort === columnIdentifier ? !this.state.sortAsc : true

    const sortedItems = objectList.sort((a, b) =>
      sortAsc
        ? a[columnIdentifier] > b[columnIdentifier]
          ? 1
          : -1
        : a[columnIdentifier] < b[columnIdentifier]
          ? 1
          : -1
    )

    this.setState({
      sort: columnIdentifier,
      sortAsc: sortAsc,
      currentPage: 1,
      items: sortedItems
    })
  }

  getItemsForCurrentPage = () => {
    const { objectsPerPage } = this.props
    const { currentPage, items } = this.state

    return [...Array(objectsPerPage).keys()].reduce((acc, val) => {
      const index = val + (currentPage - 1) * objectsPerPage
      const item = items[index] || false
      if (item) acc.push(item)

      return acc
    }, [])
  }

  render () {
    const {
      footerObject,
      columns,
      renderCustomCell,
      onRenderFooter
    } = this.props
    return (
      <div>
        <List
          objectList={this.getItemsForCurrentPage()}
          footerObject={footerObject}
          columns={columns}
          renderCustomCell={renderCustomCell}
          onRenderFooter={onRenderFooter}
          onPaginate={() => {}} // We are overwriting the pagination in this file, so we're voiding the onPaginate callback
          onSort={this.handleSort}
          sort={this.state.sort}
          sortAsc={this.state.sortAsc}
        />
        <Pagination
          pages={this.state.pageCount}
          currentPage={this.state.currentPage}
          onPaginate={this.handlePagination}
        />
      </div>
    )
  }
}

export default DataTable
